import { render, staticRenderFns } from "./VideoLibFile.vue?vue&type=template&id=544160f4"
import script from "./VideoLibFile.vue?vue&type=script&lang=js"
export * from "./VideoLibFile.vue?vue&type=script&lang=js"
import style0 from "./VideoLibFile.vue?vue&type=style&index=0&id=544160f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports